import { useGetFreeCheckAttempts } from '@/hooks/common/use-get-free-check-attempts';
import s from './imei-check-page.module.scss';
import NoAttempts from '../home-page/no-attempts/no-attempts';
import { AttemptsData } from '../loading-page/types';
import Arrow from '@/icons/arrows/right.svg';
import CheckForm from '@/modules/home-page/check-form/check-form';
import Link from 'next/link';

const ImeiCheckPage = ({
  title,
  text,
  t,
  limitData,
  shouldShowSubtitle = false,
  links,
}: {
  title: string;
  text: string;
  t?: any;
  limitData: AttemptsData;
  shouldShowSubtitle?: boolean;
  links: { title: string; href: string; type?: string }[];
}) => {
  const { data, isLoading, checkAttempts } = useGetFreeCheckAttempts({
    initialData: limitData,
  });

  const getContent = () => {
    if (!isLoading && data?.remaining_attempts === 0) {
      return <NoAttempts time={data.reset_at} />;
    }

    return <CheckForm checkAttempts={checkAttempts} />;
  };

  return (
    <section>
      <h1 className={s.title}>{title}</h1>
      {shouldShowSubtitle && (
        <p
          className={s.subtitle}
          dangerouslySetInnerHTML={{ __html: t('subtitle') }}
        />
      )}
      <p className={s.text}>{text}</p>

      <div className={s.wrap}>{getContent()}</div>

      <h2 className={s.listTitle}>{t('listTitle')}</h2>
      <ul className={s.list}>
        {links?.map((device) => (
          <li key={device.href} className={s.listItem}>
            <Link prefetch={false} href={device.href}></Link>
            <p>
              {t('checkImei')} {device?.type ? device.type : ''}{' '}
              <span className={s.device}>{device.title}</span>
            </p>
            <Arrow />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ImeiCheckPage;
